import './src/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { initPosthog } from './src/core/analytics/posthog';

initPosthog();

/** Dev helper: visit once with ?showWelcome=1 to show the "/" marketing landing again (clears onboarding flags). */
if (import.meta.env.DEV) {
  try {
    const q = new URLSearchParams(window.location.search);
    if (q.get('showWelcome') === '1') {
      localStorage.removeItem('p2t_onboarding_done');
      localStorage.removeItem('hasVisited');
      q.delete('showWelcome');
      const search = q.toString();
      const path = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
      window.history.replaceState(null, '', path);
    }
  } catch {
    /* ignore */
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

/** Drop stale SW registrations from older deploys (prevents update errors when sw.js is not served). */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then((registrations) =>
    Promise.all(registrations.map((registration) => registration.unregister())),
  );
}